import { HubConnectionState } from '@microsoft/signalr';
import { TFunction } from 'i18next';

export const getTranslatedConnectionState = (
  connectionState: HubConnectionState,
  t: TFunction
): string => {
  switch (connectionState) {
    case HubConnectionState.Connected:
      return t('connected');
    case HubConnectionState.Connecting:
      return t('connecting');
    case HubConnectionState.Reconnecting:
      return t('reconnecting');
    case HubConnectionState.Disconnecting:
      return t('disconnecting');
    case HubConnectionState.Disconnected:
      return t('disconnected');
    default:
      return String(connectionState);
  }
};
